export default __webpack_public_path__ + "static/media/quadriceps.a0d62172.png";